export default "__VITE_ASSET__uW1Bi5Pr__"